import * as React from 'react';
import { IconButton, Typography, Box } from '@mui/material';
const Day = props => {
    return (<Box sx={{
            display: 'flex',
            borderRadius: theme => (props.startOfRange ? '50% 0 0 50%' : props.endOfRange ? '0 50% 50% 0' : undefined),
            bgcolor: theme => (!props.disabled && props.highlighted ? (theme.palette.mode === 'dark' ? '#e3f2fd6e' : '#bbdefb7d') : undefined)
        }}>
      <IconButton disabled={props.disabled} onClick={props.onClick} onMouseOver={props.onHover} sx={{
            height: 36,
            width: 36,
            padding: 0,
            border: theme => (!props.disabled && props.outlined ? `1px solid ${theme.palette.primary.dark}` : undefined),
            bgcolor: theme => (!props.disabled && props.filled ? theme.palette.primary.dark : undefined),
            '&:hover': {
                bgcolor: theme => (!props.disabled && props.filled ? theme.palette.primary.dark : undefined)
            }
        }}>
        <Typography variant='body2' sx={{
            lineHeight: 1.6,
            color: theme => (!props.disabled && props.filled ? theme.palette.primary.contrastText : theme.palette.mode === 'light' ? 'initial' : undefined)
        }}>
          {!props.disabled && props.value}
        </Typography>
      </IconButton>
    </Box>);
};
export default Day;
